// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1G7Qp","row":"styles_row__nNhq8"};